import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Axios from 'axios';
import { AUTH_ROUTES } from 'routers/RouteConstants';
import Select, { components } from 'react-select';
import {
  GET_USER_TENANT_ID_WITH_NAMES,
  OTP_USER_VERIFY_API,
  USER_TENANT_ID_SELECT_VERIFY,
} from 'config/rest_endpoints';
import Logo from 'components/common/Logo';
import './style.css';

const TenantDropDown = () => {
  const [tenants, setTenants] = useState([]);
  const [response, setResponse] = useState({ message: '', load: false, error: false });
  const [selectedTenantId, setSelectedTenantId] = useState('');
  const tokenToSelectTenant = localStorage.getItem('verifyTokenToSelectTenant');

  useEffect(() => {
    getTenantId();
  }, []);

  const getTenantId = async () => {
    await Axios.get(GET_USER_TENANT_ID_WITH_NAMES)
      .then(res => {
        setTenants(res && res.data.response.data.list_tenant_IDs);
      })
      .catch(err => {
        console.log('err', err);
      });
  };

  const divStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
  };

  const handleSubmit = async () => {
    const authTokenToSelectTenant = JSON.parse(tokenToSelectTenant);
    const headers = { Authorization: 'Bearer ' + authTokenToSelectTenant };

    setResponse({ load: true, message: null, error: false });

    if (selectedTenantId !== '') {
      await Axios.post(USER_TENANT_ID_SELECT_VERIFY, { 'tenant-id': selectedTenantId }, { headers })
        .then(res => {
          let { response } = res.data;

          setResponse({ load: false, message: response.msg, error: false });
          const token = response.data.token;
          const domain = response.data.user.tenant.domain;
          let url = `${domain}?id=${token}`;
          localStorage.setItem('verifyToken', JSON.stringify(token));
          window.location = url;
        })
        .catch(err => {
          console.log('err', err);
          setResponse({ load: false, message: 'Please Select Tenant ID', error: true });
        });
    }
  };

  return (
    <article className="login-form" style={{ background: '#f1f1f1' }}>
      <article className="card login-card border-0">
        <div className="card-body">
          <div className="text-center mb-3" style={divStyle}>
            {/* <i className="fas fa-key fa-2x text-warning border-warning border-3 rounded-pill p-3 mb-3 mt-1"></i> */}
            {response.error && (
              <div className="alert alert-danger alert-styled-right alert-dismissible">
                <button type="button" className="close" data-dismiss="alert">
                  <span>×</span>
                </button>
                <span className="font-weight-semibold">{response.message}</span>
              </div>
            )}

            <h5 className="text-section-mfa">Please select a Tenant ID from the Tenant List</h5>

            <Select
              options={
                tenants ? Object.entries(tenants).map(([id, label]) => ({ value: id, label })) : []
              }
              onChange={selected => setSelectedTenantId(selected?.value || '')}
              placeholder="Select Tenant ID"
              styles={{
                container: base => ({
                  ...base,
                  width: '100%',
                  marginBottom: '30px',
                  textAlign: 'left',
                }),
                // eslint-disable-next-line no-unused-vars
                control: (base, state) => ({
                  ...base,
                  border: '2px solid #b9b9b9',
                  borderRadius: '7px',
                  boxShadow: 'none',
                  '&:hover': {
                    border: '2px solid #b9b9b9',
                  },
                }),
                option: (base, state) => ({
                  ...base,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  backgroundColor: state.isSelected
                    ? 'rgb(23, 166, 168)' // selected background
                    : state.isFocused
                      ? 'rgba(211, 211, 211)' // hover background
                      : 'white',
                  color: 'black', // always black text
                }),
                singleValue: base => ({
                  ...base,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  color: 'black', // keep black text
                }),
              }}
              components={{
                Option: props => (
                  <components.Option {...props} title={props.data.label}>
                    {props.children}
                  </components.Option>
                ),
                SingleValue: props => (
                  <components.SingleValue {...props} title={props.data.label}>
                    {props.children}
                  </components.SingleValue>
                ),
              }}
            />

            <button
              type="submit"
              onClick={handleSubmit}
              className="btn btn-theme-primary  btn-block"
            >
              Submit
              <i
                className={response.load ? 'icon-spinner2 spinner ml-2' : 'icon-paperplane ml-2'}
              ></i>
            </button>
          </div>
        </div>
      </article>
    </article>
  );
};

const MfaVerification = () => {
  const history = useHistory();
  const location = useLocation();

  const { state } = location || {};
  const [token] = useState(localStorage.getItem('token'));
  const [code, setCode] = useState('');
  const [isLoad, setIsLoad] = useState(false);
  const [respMessage, setRespMessage] = useState('');
  const [mfaName, setMfaName] = useState(state?.state?.data?.name || '');
  const [isShowTenants, setIsShowTenants] = useState(false);

  useEffect(() => {
    chkUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { state } = location;
    setMfaName(state?.state?.data?.name);
  }, [location]);

  const chkUser = () => {
    const userInfo = state?.userInfo;
    if (userInfo) {
      history.push(AUTH_ROUTES.home);
    }
  };

  const handleValue = e => {
    setCode(e.target.value);
  };

  const clearForm = () => {
    setCode('');
  };

  const submitOtpCode = e => {
    e.preventDefault();
    const payload = { otp: code };
    const authToken = JSON.parse(token);
    const headers = { Authorization: 'Bearer ' + authToken };

    setIsLoad(true);

    Axios.post(OTP_USER_VERIFY_API, payload, { headers })
      .then(res => {
        if (res.status === 200) {
          const response = res.data.response;
          if (response?.data?.user?.helium_support_user) {
            setIsShowTenants(true);
            setIsLoad(false);
            setRespMessage(response.msg);
            const token = response.data.token;
            localStorage.setItem('verifyTokenToSelectTenant', JSON.stringify(token));
            clearForm();
          } else {
            setIsShowTenants(false);
            setIsLoad(false);
            setRespMessage(response.msg);
            const token = response.data.token;
            const domain = response.data.user.tenant.domain;
            let url = `${domain}?id=${token}`;
            localStorage.setItem('verifyToken', JSON.stringify(token));
            window.location = url;
            clearForm();
          }
        }
      })
      .catch(err => {
        console.log(`err`, err);
        setIsLoad(false);
        setRespMessage('failed');
      });
  };

  useEffect(() => {
    if (!mfaName) {
      history.push(AUTH_ROUTES.login);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mfaName]);

  return (
    <section className="login-form-container">
      <article className="login-page">
        <picture className="site-logo">
          <Logo width={'450px'} height={'450px'} />
        </picture>
        {!isShowTenants ? (
          <form className="login-form" onSubmit={submitOtpCode} style={{ background: '#f1f1f1' }}>
            <div className="card border-0 shadow-0 mb-0">
              <div className="card-body content-center">
                <div className="text-center mb-3">
                  <h5 className="text-section-mfa">Please enter the one-time auth code</h5>
                  <div className="mb-4">
                    <button
                      type="button"
                      className="btn btn-light btn-block btn-float m-0 default-pointer-class"
                    >
                      <i className={`icon-google icon-2x`}></i>
                      <span>{mfaName} Code</span>
                    </button>
                  </div>
                </div>
                {respMessage === 'failed' && (
                  <div className="alert alert-danger alert-styled-right alert-dismissible">
                    <button type="button" className="close" data-dismiss="alert">
                      <span>×</span>
                    </button>
                    <span className="font-weight-semibold">OTP code is incorrect</span>
                  </div>
                )}
                {respMessage === 'user verified' && (
                  <div className="alert alert-success alert-styled-right alert-dismissible">
                    <button type="button" className="close" data-dismiss="alert">
                      <span>×</span>
                    </button>
                    <span className="font-weight-semibold">Account verified successfully</span>
                  </div>
                )}
                {respMessage !== 'user verified' && (
                  <div>
                    <div className="form-group form-group-feedback form-group-feedback-right">
                      <input
                        type="text"
                        className="form-control"
                        name="code"
                        value={code}
                        onChange={handleValue}
                        placeholder={`${mfaName} Code`}
                        autoFocus
                        disabled={isLoad}
                      />
                      <div className="form-control-feedback">
                        <i className="fas fa-key mr-3 font-s-16" style={{ color: '#999' }}></i>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="btn btn-theme-primary btn-block"
                      disabled={isLoad}
                    >
                      Submit
                      <i
                        className={isLoad ? 'icon-spinner2 spinner ml-2' : 'icon-paperplane ml-2'}
                      ></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </form>
        ) : (
          <TenantDropDown isLoad={isLoad} />
        )}
      </article>
    </section>
  );
};

export default MfaVerification;
